<template>
    <Breadcrumbs main="Ecommerce" title="Pricing" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <pricingBlock />
                <simplePricing />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const simplePricing = defineAsyncComponent(() => import("@/components/theme/ecommerce/pricing/simplePricing.vue"))
const pricingBlock = defineAsyncComponent(() => import("@/components/theme/ecommerce/pricing/pricingBlock.vue"))
</script>